import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { PastMeetingSummary } from 'lfx-pcc';
import { DateTime } from 'luxon';

@Component({
  selector: 'lfx-meeting-summary-header',
  templateUrl: './meeting-summary-header.component.html',
  styleUrls: ['./meeting-summary-header.component.scss'],
  standalone: true,
  imports: [DatePipe],
})
export class MeetingSummaryHeaderComponent {
  @Input({ required: true }) public meeting: PastMeetingSummary;

  public get endTime(): string {
    return DateTime.fromISO(this.meeting.pastMeetingStartTime).setZone(this.meeting.timezone).plus({ minutes: this.meeting.pastMeetingDuration }).toString();
  }
}
